<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefOrderList' }">
          已办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>详细信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info :document-i-d="documentID" @initedBaseInfo="initedBaseInfo" />
    <product :document-i-d="documentID" />
  </div>
</template>
<script type="es6">
import baseInfo from '../baseInfo';
import product from './product';
export default {
  data () {
    return {
      baseInfo: null
    };
  },
  components: {
    baseInfo,
    product
  },
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  computed: {},
  methods: {
    initedBaseInfo (val) {
      this.baseInfo = val;
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss"></style>
